import styled from "@emotion/styled";
import colors from "../../styles/colors";
import { getCurrentStateInputField, getPlaceholderTextColor, } from "../InputField/InputField.styled";
/**
 * Styled Input TextArea field component.
 */
export const StyledInputTextAreaField = styled.textarea `
  font-family: Inter;
  flex-grow: 1;
  border-radius: 0.375rem;
  border: 0.078rem solid ${colors["color-gray-100"]};
  padding: 0.75rem;
  font-size: 0.875rem;
  resize: none;

  ::placeholder {
    color: ${colors["color-gray-100"]};
  }

  :hover {
    box-shadow: 0rem 0.125rem 0.25rem 0rem rgba(0, 0, 0, 0.1),
      0rem 0rem 0.063rem 0rem rgba(0, 0, 0, 0.28);

    ::placeholder {
      color: ${(props) => getPlaceholderTextColor(props.showError, props.showWarning)};
    }
  }

  :focus {
    border: 0.078rem solid ${colors["color-blue-120"]};
    outline-width: 0;
    background-color: ${colors["color-blue-30"]};
    box-shadow: 0rem 0.125rem 0.25rem 0rem rgba(0, 112, 210, 0.15);

    ::placeholder {
      color: ${(props) => getPlaceholderTextColor(props.showError, props.showWarning)};
    }
  }

  :disabled {
    border: 0.078rem solid ${colors["color-gray-30"]};
    background-color: ${colors["color-gray-30"]};
    color: ${colors["color-gray-120"]};

    :hover {
      box-shadow: none;

      ::placeholder {
        color: ${colors["color-gray-120"]};
      }
    }
  }

  ${(props) => getCurrentStateInputField(props.showError, props.showWarning)}
`;
//# sourceMappingURL=InputTextAreaField.styled.js.map